<template>
    <table class="dt-table dt-table__flex-mobile">
        <thead>
            <tr>
                <th class="dt-table__cell--narrow">
                    {{ l('ORDER_LIST.HEADING_REFERENCE') }}
                </th>

                <th class="dt-table__cell--narrow">
                    {{ l('ORDER_LIST.DATE') }}
                </th>

                <th>{{ l('ORDER_LIST.HEADING_CUSTOMER') }}</th>

                <th class="dt-table__cell--narrow mobile-only">
                    {{ l('ORDER_LIST.HEADING_TOTAL') }}
                </th>

                <th v-if="redeemSession">
                    {{ l('ORDER_LIST.HEADING_REDEEM') }}
                    <small>
                        {{ l('ORDER_LIST.HEADING_REDEEM_FOR') }}
                        {{ timeFilter(redeemSession.session.startTime, true) }}
                    </small>
                </th>

                <th class="dt-table__cell--narrow dt-table__cell--last orders-list--actions-col-heading">
                    <slot></slot>
                </th>
            </tr>
        </thead>
        <tbody>
            <OrdersListOrder v-for="order in orders"
                             :key="order.ID"
                             :order="order"
                             :redeem-session="redeemSession"
                             class="dt-table__row--clickable" />
        </tbody>
    </table>
</template>

<script>
import OrdersListOrder from '@/epos/vue/components/Orders/OrdersListOrder';

export default {
    components: { OrdersListOrder },

    props: {
        /**
         * @type {Order[]}
         */
        orders: {
            type: Array,
            required: true,
        },

        /**
         * @type {SessionWithEvent|null}
         */
        redeemSession: {
            type: Object,
            default: null,
        },
    },
};
</script>

<style lang="less">
.orders-list--actions-col-heading {
    position: relative;
    height: 55px;
    text-align: right;
    > span {
        display: block;
        position: absolute;
        top: 6px;
        right: 6px;
        white-space: nowrap;
    }
}
</style>
